import type { IOpportunityState } from '../../../service/OpportunityService';
import LocationIcon from '../../UI/Icons/LocationIcon';

function OpportunityItem({ opportunity }: { opportunity: IOpportunityState }) {
  const imgUrl = `https://placeimg.com/640/480/arch/${Math.floor(Math.random() * (1000 + 1))}`;
  const totalTask = Math.floor(Math.random() * (700 - 100) + 700);
  const completed_task = Math.floor(Math.random() * (750 + 1));
  const percentCompleted = ((completed_task / totalTask) * 100).toFixed(0);

  return (
    <div className='shadow-2xl rounded-md transform hover:scale-105'>
      <div className='my-2 w-auto shadow-md rounded relative'>
        <div className='imageContainer relative hover:opacity-70'>
          <div className='flex text-white absolute bottom-0 m-4 items-center'>
            <img
              className='h-16 w-16 rounded-full object-cover object-center'
              src='https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80'
              alt=''
            />
            <div className='flex flex-col font-bold ml-4'>
              <span>Melissa William</span>
              <span>Project Team Lead</span>
            </div>
          </div>
          <img src={imgUrl} alt='house' className='img w-auto rounded-t-md' />
        </div>
        <div className='p-3 text-gray-900 bg-white rounded-b-md'>
          <div className='px-2'>
            <div className='flex justify-between items-start'>
              <h2 className='font-bold mt-0 mb-1'>{opportunity.opportunityInfo.name}</h2>
              {completed_task === totalTask && (
                <p className='text-xs border-2 border-green-500 bg-green-100 px-2 py-0.5 text-green-600 rounded-md font-medium'>
                  Completed
                </p>
              )}
              {completed_task !== totalTask && (
                <p className='text-xs border-2 border-yellow-400 bg-yellow-100 px-2 py-0.5 text-yellow-700 rounded-md font-medium'>
                  In Progress
                </p>
              )}
            </div>

            <div className='flex text-blue-500 gap-1'>
              <LocationIcon />
              <p className='break-words text-blue-500 underline'>
                {opportunity.opportunityInfo.address}, {opportunity.opportunityInfo.city}, {opportunity.opportunityInfo.state}, {'no Zip'}
              </p>
            </div>

            <p className='mt-2 text-sm'>
              <strong>Start Date :</strong> <span className='text-gray-500'>June 13, 2021</span>
            </p>
          </div>

          <div className='right flex justify-around text-center text-sm mt-4'>
            <div className='flex flex-col'>
              <p className='mx-2 text-gray-900 '>Task:</p>{' '}
              <div className='text-green-500 font-semibold'>
                {completed_task}/{totalTask}
              </div>
            </div>
            <div className='flex flex-col'>
              <p className='mx-2 text-gray-900'>Deliverables:</p> <div className='text-yellow-500 font-semibold'>100/163</div>{' '}
            </div>
            <div className='flex flex-col'>
              <p className='mx-2 text-gray-900'>Milestones:</p> <div className='text-red-500 font-semibold'>40/49</div>{' '}
            </div>
          </div>

          <div className='flex flex-col justify-between py-5'>
            <p className='mb-2 text-gray-900 text-sm font-semibold'>Project Health:</p>{' '}
            <div className='relative'>
              <div className='absolute w-full h-3 bg-gray-300 rounded-full'></div>
              <div
                className={`absolute h-3 rounded-full ${parseInt(percentCompleted, 10) > 50 ? 'bg-green-500' : 'bg-yellow-500'}`}
                style={{ width: `${percentCompleted}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpportunityItem;
